import { OPEN_ERROR_MODAL, CLOSE_ERROR_MODAL } from "./actionTypes";

function openErrorModal(error: any) {
  return {
    type: OPEN_ERROR_MODAL,
    data: error
  };
};

function closeErrorModal() {
  return {
    type: CLOSE_ERROR_MODAL
  };
};

export {
  openErrorModal,
  closeErrorModal
}